import BHowFirstEuroBox from './BHowFirstEuroBox'

export default BHowFirstEuroBox
